import {
    Card,
    DataTable,
    EmptyState,
    Page,
    Select,
    Spinner,
    Stack,
    Thumbnail,
} from "@shopify/polaris"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import moment from "moment"
import React, { Component } from "react"
import Preloader from "../../components/Preloader"
import axios from "../../funcs/axios"
import { connect } from "react-redux"
import Actions from "./../../actions"
import { bindActionCreators } from "redux"
import "./style.scss"

function mapStateToProps(state) {
    return {
        parent_pages: state.parent_pages,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class StatisticsActivity extends Component {
    _isMounted = false
    constructor(props) {
        super(props)
        this.state = {
            listProduct: [],
            loaded: false,
            todosPerPage: 50,
            currentPage: 1,
            todosPerPage: 50,
            rows: [],
            selected: "product",
            selectedDays: "7days",
            subDays: 6,
            arrayMonth: [],
            variant: false,
            appWaiting: true,
            arrayMember: [],
            arrayGuest: [],
            chartMember: [],
            charGuest: [],
            chartMonth: [],
            chartMonth2: [],
            countMonth: 1,
            countMonth2: 1,
            report: false,
        }
    }

    componentDidMount() {
        this._isMounted = true
        const { actions } = this.props
        this.loadStaticsProduct()
    }


    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    loadStaticsProduct = () => {
        let obj = {
            checkVariant: this.state.variant,
        }
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/statistic-activity`, obj)
            .then((res) => {
                if (this._isMounted) {
                    this.setState({ listProduct: res.data.result, loaded: true, appWaiting: false })
                }
            })
            .then(() => this.loadAllProduct("descending"))
    }

    handlePagination(rows) {
        const { currentPage, todosPerPage } = this.state
        // Logic for displaying current todos
        const indexOfLastTodo = currentPage * todosPerPage
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage
        const currentTodos = rows.slice(indexOfFirstTodo, indexOfLastTodo)
        return currentTodos
    }

    sortStatus(rows, index, direction) {
        return [...rows].sort((rowA, rowB) => {
            const amountA = rowA[index]
            const amountB = rowB[index]
            const date1 = new Date(amountA)
            const date2 = new Date(amountB)
            return direction === "descending" ? date2 - date1 : date1 - date2
        })
    }

    sortDate(rows, direction) {
        return [...rows].sort((rowA, rowB) => {
            const amountA = rowA
            const amountB = rowB
            const date1 = new Date(amountA)
            const date2 = new Date(amountB)
            return direction === "descending" ? date2 - date1 : date1 - date2
        })
    }

    handleSelectChange = (val) => {
        this.setState({ selected: val, appWaiting: true })
        if (val == "product") {
            this.setState({ variant: false })
        } else {
            this.setState({ variant: true })
        }
        setTimeout(() => {
            this.loadStaticsProduct()
        }, 0)
    }

    handleSelectDaysChange = (val) => {
        let subDays = 0
        switch (val) {
            case "7days":
                subDays = 6
                break
            case "30days":
                subDays = 29
                break
            case "60days":
                subDays = 59
                break
            default:
                subDays = 6
                break
        }
        this.setState({ selectedDays: val, subDays })
        setTimeout(() => {
            this.handleShowChart()
            this.loadAllProduct("descending")
        }, 0)
    }

    loadChartMonth(dataChart, first, last, status) {
        // sort Date acending
        dataChart = this.sortDate(dataChart, "ascending")
        //count item duplicate {date : count}
        let result = dataChart.reduce((obj, item) => {
            obj[item] = (obj[item] || 0) + 1
            return obj
        }, {})

        //result {dsds: ffgf, gfgfg: rerere}

        let dateTimeFirst = new Date(first).getTime() //first day
        let dateTimeLast = new Date(last).getTime() //last day

        //delete date later than subDays ago
        for (let key in result) {
            let dateTimeKey = new Date(key).getTime()
            if (dateTimeKey < dateTimeFirst || dateTimeKey > dateTimeLast) {
                delete result[key]
            }
        }

        let countMonth = 0

        //Calculate day from array date to subsDay date
        let array = []
        let lastKey = ""
        for (let key2 in result) {
            let dateTimeKey = new Date(key2).getTime()
            let Difference_In_Time = dateTimeKey - dateTimeFirst
            let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24)
            if (Difference_In_Days >= 1) {
                let count = Difference_In_Days - array.length
                for (let i = 0; i < count; i++) {
                    array.push(0)
                }
            }
            array.push(result[key2])
            lastKey = key2
            countMonth += result[key2]
        }
        //Calculate day from last date to current date
        let dateTimeKey2 = new Date(lastKey).getTime()
        let Difference_In_Time2 = dateTimeLast - dateTimeKey2
        let Difference_In_Days2 = Math.floor(Difference_In_Time2 / (1000 * 3600 * 24))
        if (Difference_In_Days2 >= 1) {
            for (let i = 0; i < Difference_In_Days2; i++) {
                array.push(0)
            }
        }
        if (!array.length) {
            for (let i = 0; i <= dateTimeLast.getDay(); i++) {
                array.push(0)
            }
        }

        if (status == "last") {
            this.setState({ chartMonth: array, countMonth })
        } else {
            this.setState({ chartMonth2: array, countMonth2: countMonth })
        }
    }

    loadChart(dataChart, status) {
        let { subDays } = this.state
        // sort Date acending
        dataChart = this.sortDate(dataChart, "ascending")

        //count item duplicate {date : count}
        let result = dataChart.reduce((obj, item) => {
            obj[item] = (obj[item] || 0) + 1
            return obj
        }, {})

        //get subDays ago
        let date = moment().subtract(subDays, "days").format("MM/DD/YYYY") // 6 days ago
        let dateTime = new Date(date).getTime()

        //delete date later than subDays ago
        for (let key in result) {
            let dateTimeKey = new Date(key).getTime()
            if (dateTimeKey < dateTime) {
                delete result[key]
            }
        }

        //Calculate day from array date to subsDay date
        // let index = 0
        let array = []
        let lastKey = ""
        for (let key2 in result) {
            let dateTimeKey = new Date(key2).getTime()
            let Difference_In_Time = dateTimeKey - dateTime
            let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24)
            if (Difference_In_Days >= 1) {
                let count = Difference_In_Days - array.length
                for (let i = 0; i < count; i++) {
                    array.push(0)
                }
            }
            array.push(result[key2])
            // index++
            lastKey = key2
        }

        //Calculate day from last date to current date
        let dateTimeKey2 = new Date(lastKey).getTime()
        let currentDate = new Date().getTime()
        let Difference_In_Time2 = currentDate - dateTimeKey2
        let Difference_In_Days2 = Math.floor(Difference_In_Time2 / (1000 * 3600 * 24))
        if (Difference_In_Days2 >= 1) {
            for (let i = 0; i < Difference_In_Days2; i++) {
                array.push(0)
            }
        }
        if (!array.length) {
            for (let i = 0; i <= subDays; i++) {
                array.push(0)
            }
        }
        if (status == "member") {
            this.setState({ chartMember: array })
        } else {
            this.setState({ charGuest: array })
        }
    }

    handleShowChart() {
        let { arrayMember, arrayGuest, arrayMonth } = this.state
        this.loadChart(arrayMember, "member")
        this.loadChart(arrayGuest, "guest")
        // let _date = new Date()
        // let firstDay = new Date(_date.getFullYear(), _date.getMonth() - 1, 1)
        // let lastDay = new Date(_date.getFullYear(), _date.getMonth(), 0)
        // let firstDay2 = new Date(_date.getFullYear(), _date.getMonth() - 2, 1)
        // let lastDay2 = new Date(_date.getFullYear(), _date.getMonth() - 1, 0)
        // let resultLastDay = 0
        // let lastDayFormat = moment(lastDay).format("DD/MM/YYYY").split("/")
        // let lastDayFormat2 = moment(lastDay2).format("DD/MM/YYYY").split("/")
        // if (+lastDayFormat[0] > +lastDayFormat2[0]) {
        //     resultLastDay = +lastDayFormat2[0]
        // } else {
        //     resultLastDay = +lastDayFormat[0]
        // }
        // let newLastdDay = new Date(_date.getFullYear(), _date.getMonth() - 1, resultLastDay)
        // let newLastdDay2 = new Date(_date.getFullYear(), _date.getMonth() - 2, resultLastDay)
        // this.loadChartMonth([...arrayMonth], firstDay, newLastdDay, "last")
        // this.loadChartMonth([...arrayMonth], firstDay2, newLastdDay2, "last2")
    }

    loadAllProduct(direction) {
        let rows = []
        const { listProduct, subDays } = this.state
        let arrayMember = [],
            arrayGuest = [],
            arrayMonth = []
        listProduct.forEach((element) => {
            let array = []
            //Calculate day from last date to current date
            let date = moment().subtract(subDays, "days").format("MM/DD/YYYY") // 6 days ago
            let dateTime = new Date(date).getTime()
            if (+element.date >= dateTime) {
                array.push(<Thumbnail source={element.featured_image} alt={element.title} />)
                array.push(
                    <a href={element.uri} target="_blank">
                        {element.title}
                    </a>,
                )
                if (element.email) {
                    array.push(element.email)
                    arrayMember.push(moment(new Date(+element.date)).format("MM/DD/YYYY"))
                } else {
                    array.push("Guest")
                    arrayGuest.push(moment(new Date(+element.date)).format("MM/DD/YYYY"))
                }
                array.push(moment(new Date(+element.date)).format("MM/DD/YYYY"))
                rows.push(array)
            }
            arrayMonth.push(moment(new Date(+element.date)).format("MM/DD/YYYY"))
        })
        if (direction == "descending") {
            rows = this.sortStatus(rows, 3, "descending")
        } else {
            rows = this.sortStatus(rows, 3, "ascending")
        }
        this.setState({ rows, appWaiting: false, arrayMember, arrayGuest, arrayMonth })

        setTimeout(() => {
            this.handleShowChart()
            // this.props.parentCallback(true)
        }, 0)
    }

    handleViewReport() {
        this.setState({ report: true })
    }

    render() {
        const {
            loaded,
            rows,
            selected,
            appWaiting,
            arrayMember,
            arrayGuest,
            chartMember,
            charGuest,
            chartMonth,
            chartMonth2,
            selectedDays,
            subDays,
            listProduct,
            countMonth2,
            countMonth,
            report,
        } = this.state
        let date = moment().subtract(subDays, "days").format("DD/MM/YYYY").split("/")
        let _date = new Date()
        let firstDay = new Date(_date.getFullYear(), _date.getMonth() - 1, 1)
        let testDate = moment(firstDay).format("DD/MM/YYYY").split("/")
        let percent = countMonth / countMonth2
        let checkIns = false
        if (percent >= 1) {
            checkIns = true
            percent = (percent - 1) * 100
        } else {
            percent = (1 - percent) * 100
        }
        const optionsChart = {
            // chart: {
            //     type: "spline",
            // },
            chart: {
                animation: {
                    duration: 1000,
                },
            },
            title: {
                text: "",
            },
            xAxis: {
                type: "datetime",
            },
            yAxis: {
                title: {
                    text: "",
                },
            },
            plotOptions: {
                series: {
                    pointStart: Date.UTC(date[2], date[1] - 1, date[0]),
                    pointInterval: 24 * 3600 * 1000, // one day
                },
            },
            series: [
                {
                    name: "Members",
                    data: chartMember,
                    // animation: {
                    //     duration: 1000,
                    // },
                },
                {
                    name: "Guests",
                    data: charGuest,
                    // animation: {
                    //     duration: 1000,
                    // },
                },
            ],
        }

        const optionsChart2 = {
            // chart: {
            //     type: "spline",
            // },
            chart: {
                animation: {
                    duration: 1000,
                },
                type: "line",
            },
            title: {
                text: "",
            },
            tooltip: {
                shared: true,
                useHTML: true,
                dateTimeLabelFormats: {
                    day: "Day: %e ",
                },
            },
            xAxis: {
                type: "datetime",
                showLastLabel: true,
                endOnTick: true,
                title: { text: "" },
            },
            yAxis: { title: { text: "" } },
            plotOptions: {
                series: {
                    pointStart: Date.UTC(testDate[2], testDate[1] - 1, testDate[0]),
                    pointInterval: 24 * 3600 * 1000, // one day
                },
            },
            legend: { enabled: true },

            column: {
                //stacking:'normal',
                groupPadding: 0.05,
                pointPadding: 0.05,
            },
            columnrange: {
                groupPadding: 0.05,
                pointPadding: 0.05,
            },
            errorbar: {
                groupPadding: 0.05,
                pointPadding: 0.05,
                showInLegend: true,
            },
            line: {
                lineWidth: 1,
                marker: {
                    enabled: false,
                    symbol: "circle",
                    radius: 4,
                },
            },
            scatter: {
                marker: {
                    symbol: "circle",
                    radius: 5,
                },
            },
            spline: {
                lineWidth: 1,
                marker: {
                    enabled: false,
                    symbol: "circle",
                    radius: 4,
                },
            },
            series: [
                {
                    name: `Feb, ${testDate[2]}`,
                    data: chartMonth,
                    // animation: {
                    //     duration: 1000,
                    // },
                },
                {
                    name: `Jan, ${testDate[2]}`,
                    data: chartMonth2,
                    dashStyle: "shortdot",
                    // animation: {
                    //     duration: 1000,
                    // },
                },
            ],
        }

        let data = this.handlePagination(rows)
        const options = [
            { label: "Product", value: "product" },
            { label: "Variant", value: "variant" },
        ]
        const options2 = [
            { label: "Last 7 days", value: "7days" },
            { label: "Last 30 days", value: "30days" },
            { label: "Last 60 days", value: "60days" },
        ]
        return loaded ? (
            <div>
                <div>
                    <div style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}>
                        <Select
                            options={options2}
                            onChange={(val) => this.handleSelectDaysChange(val)}
                            value={selectedDays}
                        />
                        <div style={{ flex: "2" }}></div>
                    </div>
                    <Stack distribution="equalSpacing" alignment="center">
                        <Stack.Item fill>
                            <Stack alignment="center" spacing="extraLoose">
                                <div className="page-title">Statistics</div>
                            </Stack>
                        </Stack.Item>
                    </Stack>
                    <div className="stat-product">
                        <div className="stat-item">
                            <div className="stat-num">{data.length}</div>
                            <div className="stat-title">
                                {selected == "product" ? "Product" : "Product Variant"}
                            </div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-num">{arrayMember.length}</div>
                            <div className="stat-title">
                                <svg width="12" height="12" viewBox="0 0 26 22">
                                    <path
                                        d="M12.8194 22C12.5802 22 12.3665 21.9145 12.1785 21.7436L3.25614 13.1289L2.87156 12.7444C2.70063 12.5734 2.43569 12.2572 2.07675 11.7957C1.71781 11.3342 1.39305 10.8727 1.10247 10.4112C0.811898 9.94972 0.555509 9.37712 0.333306 8.69341C0.111102 8.00971 0 7.35164 0 6.71922C0 4.61683 0.606787 2.97594 1.82036 1.79655C3.03394 0.617164 4.70901 0.018924 6.84558 0.00183139C7.42673 0.00183139 8.02497 0.104384 8.64031 0.309495C9.25564 0.514607 9.82824 0.796636 10.3581 1.15558C10.888 1.51452 11.3495 1.83928 11.7426 2.12986C12.1357 2.42043 12.4947 2.74519 12.8194 3.10414C13.1613 2.76228 13.5202 2.43752 13.8963 2.12986C14.2723 1.82219 14.7338 1.49743 15.2808 1.15558C15.8277 0.813728 16.4003 0.531699 16.9986 0.309495C17.5968 0.0872916 18.1951 -0.0152612 18.7933 0.00183139C20.9299 0.00183139 22.605 0.600071 23.8185 1.79655C25.0321 2.99303 25.6389 4.6382 25.6389 6.73204C25.6389 8.82588 24.545 10.9667 22.3571 13.1546L13.4604 21.7436C13.2895 21.9145 13.0758 22 12.8194 22Z"
                                        fill="#D80028"
                                    />
                                </svg>
                                <span>By members</span>
                            </div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-num">{arrayGuest.length}</div>
                            <div className="stat-title">
                                <svg width="12" height="12" viewBox="0 0 26 22">
                                    <path
                                        d="M12.8194 22C12.5802 22 12.3665 21.9145 12.1785 21.7436L3.25614 13.1289L2.87156 12.7444C2.70063 12.5734 2.43569 12.2572 2.07675 11.7957C1.71781 11.3342 1.39305 10.8727 1.10247 10.4112C0.811898 9.94972 0.555509 9.37712 0.333306 8.69341C0.111102 8.00971 0 7.35164 0 6.71922C0 4.61683 0.606787 2.97594 1.82036 1.79655C3.03394 0.617164 4.70901 0.018924 6.84558 0.00183139C7.42673 0.00183139 8.02497 0.104384 8.64031 0.309495C9.25564 0.514607 9.82824 0.796636 10.3581 1.15558C10.888 1.51452 11.3495 1.83928 11.7426 2.12986C12.1357 2.42043 12.4947 2.74519 12.8194 3.10414C13.1613 2.76228 13.5202 2.43752 13.8963 2.12986C14.2723 1.82219 14.7338 1.49743 15.2808 1.15558C15.8277 0.813728 16.4003 0.531699 16.9986 0.309495C17.5968 0.0872916 18.1951 -0.0152612 18.7933 0.00183139C20.9299 0.00183139 22.605 0.600071 23.8185 1.79655C25.0321 2.99303 25.6389 4.6382 25.6389 6.73204C25.6389 8.82588 24.545 10.9667 22.3571 13.1546L13.4604 21.7436C13.2895 21.9145 13.0758 22 12.8194 22Z"
                                        fill="#D80028"
                                    />
                                </svg>
                                <span>By guests</span>
                            </div>
                        </div>
                    </div>
                    {listProduct && listProduct.length ? (
                        <div>
                            <HighchartsReact highcharts={Highcharts} options={optionsChart} />
                        </div>
                    ) : (
                        ""
                    )}
                    <Page
                        title={
                            selected == "product" ? "Activiy Product" : "Activiy Product Variant"
                        }
                    >
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <div style={{ flex: "2" }}></div>
                            <Select
                                options={options}
                                onChange={(val) => this.handleSelectChange(val)}
                                value={selected}
                            />
                        </div>
                        {listProduct && listProduct.length ? (
                            <Card>
                                <DataTable
                                    columnContentTypes={["text", "text", "text", "text"]}
                                    headings={["Image", "Product", "Email", "Date"]}
                                    rows={data}
                                    sortable={[false, false, false, true]}
                                    defaultSortDirection="descending"
                                    initialSortColumnIndex={3}
                                    onSort={(index, direction) => this.loadAllProduct(direction)}
                                />
                            </Card>
                        ) : (
                            <Card>
                                <Card.Section>
                                    <EmptyState
                                        heading="No product in wishlist"
                                        image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                                    >
                                        <p>
                                            We couldn't find any result. Please add to wishlist for
                                            product statistics
                                        </p>
                                    </EmptyState>
                                </Card.Section>
                            </Card>
                        )}
                    </Page>
                </div>
                {appWaiting ? <Preloader /> : null}
            </div>
        ) : (
            <Stack distribution="center">
                <div style={{ marginTop: "20px", display: "flex" }}>
                    <Spinner
                        accessibilityLabel="Loading more customers"
                        size="large"
                        color="teal"
                    />
                </div>
            </Stack>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsActivity)
